const getScrollDistance = ({
  value,
  isRightToLeft,
  carouselRefCurrent,
  offset,
}: {
  value: { offsetLeft: number; offsetWidth: number };
  isRightToLeft: boolean;
  carouselRefCurrent: HTMLDivElement;
  // Offset should be the CDS grid horizontal padding (16px)
  // to align the items with the CDS grid on the left side (or right side for RTL) after scrolling.
  offset: number;
}) => {
  const distance = isRightToLeft
    ? carouselRefCurrent.offsetWidth - value.offsetLeft - value.offsetWidth - offset
    : value.offsetLeft - offset;

  return distance;
};

export default getScrollDistance;
